import { ITableHeader } from './getMenuItems';
import metrics from 'maps/metrics';

export default getTableHeaders;

export const defaultHeaders = [
  { ...metrics['customerId'] },
  { ...metrics['displayName'], label: 'Playlist' },
];

function getTableHeaders(isTopList?: boolean): ITableHeader[] {
  if (isTopList) {
    return [
      ...defaultHeaders,
      { ...metrics['new_track_count'] },
      { ...metrics['track_count'] },
    ];
  }
  return [
    { ...metrics['playlistTerritories'], label: 'Playlist\nTerritory' },
    {
      ...metrics['stream_count_this_week_to_date'],
      label: 'Streams\nthis week',
    },
    {
      ...metrics['stream_count_last_week_to_date'],
      label: 'Last week\nto date',
    },
    { ...metrics['stream_wow_in_progress'], label: 'Streams\nweek\nover week' },
    { ...metrics['skiprate_this_week_to_date'], label: 'Skiprate' },
    { ...metrics['track_count'] },
    { ...metrics['followers'] },
    { ...metrics['position'] },
  ];
}
